import { PreviewEspot, PreviewMegaMenu } from '#components'

export default {
  VfCanvasEspotBanner: PreviewEspot,
  VfCanvasInlineGrid: PreviewEspot,
  VfCanvasMegaMenu: PreviewMegaMenu
}
